import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { Typography } from '@material-ui/core';
import { DelaStarIcon } from '~/modules/common/components/Icons';
import useStyles from './useStyles';

export const ResourceMatchItemNoMatches = ({ dataQeId }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const resourceMatchItemNoMatchesDataQeId = dataQeId
    ? `${dataQeId}_ResourceMatchItemNoMatches`
    : undefined;

  return (
    <div
      data-qe-id={resourceMatchItemNoMatchesDataQeId}
      className={classes.itemRoot}
    >
      <div className={classes.itemContainer}>
        <div className={classes.itemTextContainer}>
          <Typography variant="caption" color="textPrimary">
            {formatMessage({
              id: 'resourceMatchItem.resourceMatcher'
            })}
          </Typography>
          <DelaStarIcon className={classes.itemDelaStarIcon} />
        </div>
        <div
          className={classNames(
            classes.itemTextContainer,
            classes.itemNegativeMargin
          )}
        >
          <Typography variant="body2" color="textSecondary">
            {formatMessage({
              id: 'resourceMatchItem.noMatchesFound'
            })}
          </Typography>
        </div>
      </div>
    </div>
  );
};

ResourceMatchItemNoMatches.propTypes = {
  dataQeId: PropTypes.string
};

export default ResourceMatchItemNoMatches;
